import { ConversationsInputBlockComponent } from './ConversationsInputBlock'
import { CardBlockComponent } from './CardBlock'
import { FlexBlockComponent } from './FlexBlock'
import { InputEditorBlockComponent } from './InputEditorBlock'
import { PromptBlockComponent } from './PromptBlock'
import { ResponsesBlockComponent } from './ResponsesBlock'
import { SelectBlockComponent } from './SelectBlock'
import { TextBlockComponent } from './TextBlock'
import { ConversationsTurnBlockComponent } from './ConversationsTurnBlock'
import { ButtonBlockComponent } from './ButtonBlock'

export const builtInBlockComponents = [
    {
        type: 'prompt-block' as const,
        component: PromptBlockComponent,
        schema: {
            state: {},
            methods: {},
        } as const,
    },
    {
        type: 'responses-block' as const,
        component: ResponsesBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'select-block' as const,
        component: SelectBlockComponent,
        schema: {
            state: {
                layout: {
                    type: 'enum' as const,
                    values: ['single-row-view', 'grid-view'] as const,
                },
            },
            methods: {
                setLayout: {
                    type: 'function' as const,
                    parameters: {
                        layout: {
                            type: 'enum' as const,
                            values: ['single-row-view', 'grid-view'] as const,
                        },
                    },
                },
            },
        } as const,
    },
    {
        type: 'card-block' as const,
        component: CardBlockComponent,
        schema: {
            state: {},
            methods: {},
        } as const,
    },
    {
        type: 'input-editor-block' as const,
        component: InputEditorBlockComponent,
        schema: {
            state: {},
            methods: {},
        } as const,
    },
    {
        type: 'flex-block' as const,
        component: FlexBlockComponent,
        schema: {
            state: {},
            methods: {},
        } as const,
    },
    {
        type: 'text-block' as const,
        component: TextBlockComponent,
        schema: {
            state: {},
            methods: {},
        } as const,
    },
    {
        type: 'conversations-input-block' as const,
        component: ConversationsInputBlockComponent,
        schema: {
            state: {},
            methods: {},
        } as const,
    },
    {
        type: 'conversations-turn-block' as const,
        component: ConversationsTurnBlockComponent,
        schema: {
            state: {},
            methods: {},
        } as const,
    },
    {
        type: 'button-block' as const,
        component: ButtonBlockComponent,
        schema: {
            state: {},
            methods: {},
        } as const,
    },
] as const
